/**
 * Deep State settings
 *
 * Settings used to configure the deep state.
 */
const dbName = 'worktango';
const version = 1;

const schema = {
  // DEPRECATED: disable storing employees in indexedDB for now
  // employees: 'id,name,email,company,employeeId,isActive,firstName,lastName'
};

export { dbName, version, schema };
